"use strict";
/* eslint-disable indent */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneFieldStyles = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.PhoneFieldStyles = styled_1.default.div `
  order: ${(props) => props.order};
  flex: ${({ flexGrow }) => flexGrow};

  &:not(:last-of-type) {
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }

  @media screen and (min-width: ${({ breakpoints = {} }) => breakpoints.screen_medium || (0, ui_theme_1.fromTheme)('screen_medium')}) {
    &:not(:last-of-type) {
      margin-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    }
  }
`;
//# sourceMappingURL=styles.js.map